// extracted by mini-css-extract-plugin
export default {"container":"coqF6","content":"ryg5O","content--no-offset":"y9vX5"};